module.exports = __webpack_public_path__ + "static/media/website-order.3af8100c.png";